module.exports = __webpack_public_path__ + "static/thumb-9-52cfaeb0374c7ad3e52e947ef8984423.jpg";